import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowDown } from 'lucide-react';
import { Button } from '../ui/Button';
function scrollToCheckout() {
  document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function Hero() {
  return <section className="relative pt-8 px-5 text-center overflow-hidden pb-[0px]" data-id="element-66">
      {/* soft decorative accents */}
      <div className="pointer-events-none absolute -top-16 -right-16 w-56 h-56 bg-violet-200/50 rounded-full blur-3xl" data-id="element-67" />
      <div className="pointer-events-none absolute top-40 -left-20 w-52 h-52 bg-rose-200/40 rounded-full blur-3xl" data-id="element-68" />

      <div className="relative" data-id="element-69">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: 'easeOut'
      }} className="text-[32px] leading-[1.15] sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-70">
          Activá el habla de tu hijo con un método paso a paso que solo requiere{' '}
          <span className="relative inline-block" data-id="element-71">
            <span className="relative z-10 text-violet-700" data-id="element-72">
              10 minutos al día
            </span>
            <span className="absolute inset-x-0 bottom-1 h-3 bg-violet-200/70 -z-0 rounded" data-id="element-73" />
          </span>
          .
        </motion.h1>

        {/* social proof */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.24
      }} className="flex items-center justify-center gap-2 mb-6" data-id="element-74">
          <div className="flex gap-0.5" data-id="element-75">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-76" />)}
          </div>
          <span className="text-sm font-semibold text-gray-600" data-id="element-77">
            +4.372 familias ya empezaron
          </span>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/iF7Xh3DJBMXHtWtFNCGH9c/3b.png" alt="Ultrapack Activador del Habla" className="w-full h-auto object-contain mb-8" data-id="element-78" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.38,
        ease: 'easeOut'
      }} data-id="element-79">
          <Button variant="green" onClick={scrollToCheckout} data-id="element-80">
            <span className="text-lg" data-id="element-81">QUIERO ACTIVAR EL HABLA DE MI HIJO</span>
          </Button>
        </motion.div>
      </div>
    </section>;
}